import React, { useEffect, useState } from "react"
import _get from "lodash/get"
import _isEmpty from "lodash/isEmpty"
import _startCase from "lodash/startCase"
import { useDispatch } from "react-redux"

import { getConfig } from "@/constants/config"
import CONSTANTS from "@/constants"

import {
  getGenericListPath,
  getCommonList,
  showToast,
} from "@/store/features/genericSlice"

import { getShortenedUrl } from "@/utils/helper"
import useContactUsi18n from "@/i18n/useContactUsi18n"

import ContactUsView from "@/components/ContactUs/v1/ContactUsView"

const ContactUs = props => {
  const { data: componentProp } = props
  const { type: sourceKeyType = "", continueShoppingUrl = "" } = componentProp
  const {
    CREATE_ACCOUNT_TYPE: { HOME_OWNER = "" },
  } = CONSTANTS

  const [activeTab, setActiveTabVal] = useState(_startCase(HOME_OWNER))
  const [helpTopic, setHelpTopic] = useState([])
  const [submitSuccess, setSubmitSuccess] = useState(false)
  const [homePagePath, setHomePagePath] = useState()
  const [legalPageLinks, setLegalPageLinks] = useState()
  const [continueShoppingUrlData, setContinueShoppingUrlData] = useState("")
  const i18n = useContactUsi18n(componentProp)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getGenericListPath())
  }, [])
  useEffect(() => {
    getConfig().then(async config => {
      const homePagePath = await getShortenedUrl(
        _get(config, "general.homepageUrl", "/")
      )
      const legalPageLinks = _get(config, "legalPageData", {})

      setHomePagePath(homePagePath)
      setLegalPageLinks(legalPageLinks)
      setContinueShoppingUrlData(
        await getShortenedUrl(continueShoppingUrl || "")
      )
    })
    if (_isEmpty(helpTopic)) getListItem()
  })

  const handleSubmit = status => {
    const container = document.getElementById("aem-contact-us-container")
    status
      ? container?.classList.add("d-none")
      : container?.classList.remove("d-none")
    setSubmitSuccess(status)
  }

  const getListItem = async () => {
    const { payload: commonList } = await dispatch(getCommonList())
    setHelpTopic(
      commonList?.find(el => el?.text === "helpTopic")?.value?.split(",")
    )
  }

  const setActiveTab = t => {
    setActiveTabVal(t)
  }

  return (
    <ContactUsView
      key={submitSuccess}
      i18n={i18n}
      helpTopic={helpTopic}
      sourceKey={sourceKeyType}
      continueShoppingUrl={continueShoppingUrlData}
      showToaster={msg =>
        showToast({
          message: msg,
          isVisible: true,
        })
      }
      homePagePath={homePagePath}
      submitSuccess={submitSuccess}
      handleSubmitMsg={handleSubmit}
      legalPages={legalPageLinks}
      setActiveTab={setActiveTab}
      activeTab={activeTab}
      authorData={componentProp}
    />
  )
}

export default ContactUs
